import DatagridHeader from '@/components/DatagridHeader'
import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import {
  Button,
  Datagrid,
  DeleteWithConfirmButton,
  EmailField,
  ExportButton,
  List,
  TextField,
  TopToolbar,
  useRefresh
} from 'react-admin'
import { InviteUser } from './InviteUser'

import PersonAddIcon from '@mui/icons-material/PersonAdd'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'

const Actions = ({ onInviteClick }: { onInviteClick: () => void }) => (
  <TopToolbar>
    <Button
      label="Invite New User"
      startIcon={<PersonAddIcon />}
      onClick={onInviteClick}
      data-testid="invite-user-button"
    />
    <ExportButton />
  </TopToolbar>
)

const EmptyList = ({ onInviteClick }: { onInviteClick: () => void }) => (
  <Box textAlign="center" p={4}>
    <Typography variant="h6">No users yet.</Typography>
    <Box mt={2}>
      <Button
        label="Invite New User"
        startIcon={<PersonAddIcon />}
        onClick={onInviteClick}
        variant="contained"
        color="primary"
        data-testid="empty-invite-button"
      />
    </Box>
  </Box>
)

export const ManageUsers = () => {
  const [modalVisible, setModalVisible] = useState(false)
  const toggleModal = () => setModalVisible(!modalVisible)
  const refresh = useRefresh()

  const handleInviteSuccess = () => {
    refresh()
  }

  return (
    <Box>
      <List
        actions={<Actions onInviteClick={toggleModal} />}
        empty={<EmptyList onInviteClick={toggleModal} />}
      >
        <Datagrid
          header={<DatagridHeader hideColumns={['Remove']} />}
          bulkActionButtons={false}
        >
          <TextField source="User Name" />
          <EmailField source="User Email" />
          <DeleteWithConfirmButton
            label="Remove"
            confirmTitle="Remove User"
            confirmContent="Are you sure you want to remove this user?"
            icon={<PersonRemoveIcon />}
          />
        </Datagrid>
      </List>
      <InviteUser
        open={modalVisible}
        onClose={toggleModal}
        onInviteSuccess={handleInviteSuccess}
      />
    </Box>
  )
}
